import { useEffect, useState } from 'react';
import Button from '../../../components/button/Button';
import { useAuth } from '../../../context/AuthContext';
import { Message } from '../../../types/Chat';
import http from '../../../api/axios';
import { apiUrl } from '../../../api/apiUrl';
import { useParams } from 'react-router-dom';
import { Loader } from '../../../components/loader/Loader';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { toast } from 'react-toastify';
import { useTranslation } from '../../../context/translationContext';
import ReactQuill from 'react-quill';

/**
 * Chat component for invoice side bar
 */
export const InvoiceSidePanelTabChat = () => {
  const [value, setValue] = useState<string>();
  const { user } = useAuth();
  const { t } = useTranslation();
  const { id } = useParams();
  const [messages, setMessages] = useState<Message[] | null>(null);
  /**
   * Loads messages for invoice
   */
  const fetchMessages = async () => {
    if (!id) return;
    const response = await http.apiGet({
      url: `${apiUrl.ACCOUNTING_DOCUMENT_MESSAGE_LIST}?parentId=${id}`,
    });
    if (response?.data) {
      setMessages(response?.data);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  /**
   * Submits message to chat
   */
  const handleSubmitMessage = async () => {
    if (!user || messages === null || value === '' || !id) return;
    try {
      const response = await http.apiPost({
        url: apiUrl.ACCOUNTING_DOCUMENT_MESSAGE_CREATE,
        data: { documentId: id, text: value },
      });
      if (response?.status === 201) {
        fetchMessages();
        toast.success('Success!');
      }
    } catch (err) {
      handleApiErrors(err);
    }
    // reset editor
    setValue('');
  };

  // toolbar options
  const toolbarOptions = [
    ['bold', 'italic', 'underline'], // toggled buttons
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ direction: 'rtl' }], // text direction
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['link', 'image'],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
  ];

  if (messages === null) return <Loader />;
  return (
    <>
      {/* chatroom */}
      <div className="h-80 overflow-y-auto p-2">
        <>
          {messages &&
            messages.map((msg: Message, index: number) => (
              <div className="border-b-2 p-2 text-sm font-normal" key={index}>
                <span className="italic">{msg.createdByUserName}</span>:{' '}
                <div dangerouslySetInnerHTML={{ __html: msg.text }} />
              </div>
            ))}
        </>
      </div>
      {/* editor */}
      <div className="mt-5 text-center">
        <div className="border border-t-1 h-max-40 text-sm font-normal">
          <div className="min-h-[150px]">
            <ReactQuill
              onChange={setValue}
              modules={{
                toolbar: toolbarOptions,
              }}
              theme="snow"
              value={value}
            />
          </div>
        </div>
        <Button title={t('general.send')} onClick={handleSubmitMessage} className={`mt-5`} />
      </div>
    </>
  );
};
